module.exports = __webpack_public_path__ + "static/media/34-1.b8b1f39d.mp3";